import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import styled from "styled-components";
import { Input } from "@vds/inputs";
import { DropdownSelect } from "@vds/selects";
// import { FormGroup as ReactFormGroup, Label as ReactLabel } from "@vzrf/react-forms";

import { media } from "utils/style";

// import { Input as ReactInput, Select as ReactSelect } from "common-components/FormContent";
import { Tooltip as ReactTooltip } from "common-components/Tooltip";
import { checkNestedObject } from "utils/checkNestedObject";
import Button from "common-components/Buttons";

class AuthorizedAgentCorrectionForm extends Component {
  componentDidMount() {

  }

  entityNumberValid = val => {
    if (val.length !== 8 && val.length !== 12) {
      return "Invalid entity number";
    }
    if (val.length === 8) {
      if (val.charAt(0).toLowerCase() !== "c") {
        return "Invalid entity number";
      }
    }
  };

  required = (value, ...label) => {

    if (value === "Please select" || value === "Seleccionar opción") {
      return "Required."
    }

    if (value || typeof value === "number") {
      return undefined;
    }

    if (label && label[2]) {
      const el = document.querySelectorAll(`[for='${label[2]}']`);
      if (el && el[0]) {
        return `${el[0].textContent} is required.`;
      }
    }
    return "Required.";
  };


  emailValid = val => {
    if (!/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val)) {
      return "Email invalid format";
    }
  };



  renderField = ({
    input,
    autoComplete,
    type,
    width,
    maxLength,
    label,
    meta: { touched, error },
    ...extra
  }) => {
    /*const {
      state_selection: {
        genericList: [{ list: stateList }]
      }
    } = this.props;*/

    const { formContent: { genericList } } = this.props;
    const { list: stateList } = genericList[1];

    //const stateList = [];


    const commonProps = {
      id: input.name,
      error: touched && error,
      autoComplete: autoComplete ? autoComplete : "on",
      "aria-describedby": `${input.name}_error`,
      ...extra
    };

    return (
      <Form width={width}>
        {/* <Label htmlFor={input.name}>
          {label}
          {/*tooltip ? <Tooltip>{tooltip}</Tooltip> : null*/}
        {/* </Label> */}
        {type === "select" ? (
          <DropdownSelect  
               {...input} 
               {...commonProps}
               required={true}
               readOnly={false}
               label={label}              
               >
            {stateList.map(state => (
              <option key={state.jsonKey} value={state.jsonValue}>
                {state.jsonValue}
              </option>
            ))}
          </DropdownSelect>
        ) : (
          <Input
            {...input}
            {...commonProps}
            required={ label === "Apt / Suite / Other" ? false : true}
            readOnly={false}
            error={touched && error ? true : false}
            errorText={error}
            label={label}            
            onKeyPress={e => {
              this.props.invalid && e.key === "Enter" && e.preventDefault();
            }}
            maxLength={maxLength ? maxLength : "50"}
          />
        )}
        {/* {touched && error && (
          <ErrorMsg role="alert" id={`${input.name}_error`}>
            {error}
          </ErrorMsg>
        )} */}
      </Form>
    );
  };

  handleCancelClick = () => {
    this.props.onCancel();
    this.props.onHideDateShow()
  };

  renderSimpleForm = (field) => {
    let validateMethods = [this.required];
    if ("email" === field.fieldInfo[0].name) {
      validateMethods.push(this.emailValid);
    }

    return (
      <Field
        component={this.renderField}
        validate={validateMethods}
        name={`${field.jsonKey}_${field.fieldInfo[0].name}`}
        label={field.fieldInfo[0].label}
      />
    )
  };

  renderAddressForm = (field) => {
    let validateMethods = [this.required];
    const addressInfo = field.fieldInfo.filter(f => f.name === "address");
    const otherInfo = field.fieldInfo.filter(f => f.name === "other");
    const cityInfo = field.fieldInfo.filter(f => f.name === "city");
    const stateInfo = field.fieldInfo.filter(f => f.name === "state");
    const zipCodeInfo = field.fieldInfo.filter(f => f.name === "zipcode");

    return (
      <AddressFormContainer >
        <fieldset>
        <div>
          <Field
            component={this.renderField}
            validate={validateMethods}
            name={`${field.jsonKey}_${addressInfo[0].name}`}
            label={addressInfo[0].label}
            data-qm-encrypt="true"
          />
        </div>
        <div>
          <Field
            component={this.renderField}
            name={`${field.jsonKey}_${otherInfo[0].name}`}
            label={otherInfo[0].label}
            data-qm-encrypt="true"
          />
        </div>
        <CityStateZipContainer>
          <div style={{ maxWidth: "130px" }}>
            <Field
              component={this.renderField}
              validate={validateMethods}
              name={`${field.jsonKey}_${cityInfo[0].name}`}
              label={cityInfo[0].label}
              data-qm-encrypt="true"
            />
          </div>
          <div style={{ maxWidth: "125px" }}>
            <Field
              component={this.renderField}
              validate={validateMethods}
              name={`${field.jsonKey}_${stateInfo[0].name}`}
              type="select"
              label={stateInfo[0].label}
              data-qm-encrypt="true"
            />
          </div>
          <div style={{ maxWidth: "75px" }}>
            <Field
              component={this.renderField}
              validate={validateMethods}
              name={`${field.jsonKey}_${zipCodeInfo[0].name}`}
              normalize={val => val.replace(/[^\d-]/g, "")}
              maxLength={5}
              label={zipCodeInfo[0].label}
              data-qm-encrypt="true"
            />
          </div>
          </CityStateZipContainer>
        </fieldset>
      </AddressFormContainer>

    )

  }

  render() {
    const { formContent: { genericList, categories, buttons } } = this.props;
    const { list: fieldList } = genericList[0];

    const keyInfo = this.props.elementId;
    const userFriendlyNameInfo = this.props.element.userFriendlyName;

    let field;

    if (keyInfo === '667') {
      const filteredField = fieldList.filter(field => field["jsonKey"] === keyInfo && field.fieldInfo && field.fieldInfo.length > 0 && field.fieldInfo[0].name === userFriendlyNameInfo);
      if (!filteredField || filteredField.length === 0) {
        field = fieldList.filter(field => field["jsonKey"] === keyInfo && field.fieldType === "RepAssistForm")
      } else {
        field = filteredField
      }
    } else {
      field = fieldList.filter(field => field["jsonKey"] === keyInfo)
    }

    if (field && field.length > 0 && field[0].fieldType && field[0].fieldType === "RepAssistForm") {
      if (this.props.showRepFlowModalForAuthorizedAgent && !this.props.showModal) {
        this.props.showRepFlowModalForAuthorizedAgent();
      }
      return null;
    }

    return (
      <Form onSubmit={this.props.onSubmit}>
        <Div>
          {
            field && field.length > 0 && field[0].fieldType && field[0].fieldInfo && field[0].fieldInfo.length > 0
              ?
              (
                field[0].fieldType === "SimpleForm" && this.renderSimpleForm(field[0])
                ||
                field[0].fieldType === "AddressForm" && this.renderAddressForm(field[0])
              )
              :
              ""
          }
        </Div>
        <ButtonContainer>
          <Button type="submit" disabled={this.props.invalid} background={buttons[2].type}>
            {buttons[2].text}
          </Button>
          <Button type="button" onClick={this.handleCancelClick} background={buttons[1].type}>
            {buttons[1].text}
          </Button>
        </ButtonContainer>
      </Form>
    );
  }
}

const mapStateToProps = ({
  form: { authAgentCorrectionInfo },
  pageContent: { agentcorrection: formContent },
  modalState
}) => ({
  authAgentCorrectionInfo,
  formContent,
  showModal: modalState.showModal,
  initialValues: {}
});

AuthorizedAgentCorrectionForm = reduxForm({
  form: "authAgentCorrectionInfo",
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true
})(AuthorizedAgentCorrectionForm);

AuthorizedAgentCorrectionForm = connect(
  mapStateToProps
)(AuthorizedAgentCorrectionForm);

export default AuthorizedAgentCorrectionForm;

// const Tooltip = styled(ReactTooltip)`
//   display: inline-block;
//   margin-left: 8px;
//   vertical-align: middle;
// `;

const Form = styled.form`
  // max-width: 385px;
  /*border-top: 4px solid #000;*/
  margin-top:10px;
  padding-top: 2px;
`;

const Div = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const ButtonContainer = styled.div`
  display: flex;
  marginTop: "40px";
  ${media.mobile`
   flex-direction: column;
  `}
`;

// const Label = styled(ReactLabel)`
//   color: #747676;
//   font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
// `;

// const FormGroup = styled(ReactFormGroup)`
//   width: 100%;
//   margin-bottom: 24px;
//   ${({ width }) =>
//     width &&
//     `
//     flex-basis: ${width}%;
//   `}
// `;

// const Input = styled(ReactInput)`
//   width: 100%;
//   max-width: 100%;
// `;

// const Select = styled(ReactSelect)`
//   width: 100% !important;
//   padding: 12px !important;
//   min-width: inherit !important;
//   height: inherit !important;
// `;

const Legend = styled.legend`
  font-size: 14px;
  line-height: 14.5px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  margin-bottom: 14px;
`;

const ErrorMsg = styled.span`
  display: block;
  font-size: 10px;
  line-height: 10px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  max-width: 173px;
  margin-top: 5px;

  ${media.mobile`
    max-width: 100%;  
  `}
`;

const AddressFormContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  flex-direction:column;
  flex-wrap: wrap;
  justify-content: space-between;
  width:100%;
`

const CityStateZipContainer = styled.div`
  display: flex;
  flex-direction:row;
  flex-wrap: wrap;
  justify-content: space-between;
`
